import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart, ArcElement, PointElement, LinearScale, Title } from 'chart.js';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { Root, classes } from './utils';

Chart.register(ArcElement, PointElement, LinearScale, Title);

// const plugins = [
//   {
//     beforeDraw(chart) {
//       const {
//         width, height, ctx, data,
//       } = chart;
//       ctx.restore();
//       const fontSize = Math.min(width / 100, height / 100);
//       ctx.font = ` bolder ${fontSize}em Poppins `;
//       ctx.textBaseline = 'middle';
//       const text = data.datasets[0].data[0];
//       const textX = Math.round((width - ctx.measureText(text).width) / 2);
//       const textY = height / 1.9;
//       ctx.fillText(text, textX, textY);
//       ctx.save();
//     },
//   },
// ];

const DonutChart = () => {
  const userDetail = useSelector((state) => state.user.user);
  const [totalCredit, setTotalCredit] = useState('');
  const [remainingCredit, setRemainingCredit] = useState('');

  useEffect(() => {
    if (userDetail && Object.keys(userDetail).length !== 0) {
      const remainingCreditAvailable =
        userDetail?.organization?.remaining_credits || 0;
      const totalCreditAvailable = userDetail?.organization?.total_credits || 0;
      setTotalCredit(totalCreditAvailable);
      setRemainingCredit(remainingCreditAvailable);
    }
  }, [userDetail]);

  const data = {
    labels: ['Total', 'Active'],
    datasets: [
      {
        label: 'My First Dataset',
        data: [totalCredit - remainingCredit, remainingCredit],
        // backgroundColor: ["#F1F1F1", "#9F77EB"],
        borderColor: ['#F1F1F1', '#9F77EB'],
        //   weight: 5,
        //   radius: '50%',
        //   borderRadius: 10,
        borderWidth: window.outerWidth <= 900 ? 5 : 10,
      },
    ],
  };

  const options = {
    cutout: 100,
    responsive: true,
    maintainAspectRatio: false,
    hover: { mode: null },
    plugins: {
      tooltip: {
        enabled: false,
      },
      legend: {
        display: false,
      },
      // title: {
      //   display: true,
      //   text: `${remainingCredit} of ${totalCredit} credits remaining`,
      //   position: 'bottom',
      //   font: responsiveFontForTitle,
      //   color: 'rgba(43, 30, 89, 1)',
      //   // padding: -50,
      // },
    },
    animation: {
      duration: 3000,
      easing: 'easeInOutQuad',
    },
  };

  const config = {
    rotation: 270,
  };
  return (
    <Root>
      <Box className={classes.donutChartBox}>
        <Doughnut
          data={data}
          options={options}
          // plugins={plugins}
          config={config}
          style={{
            height: '100%',
            width: '100%',
            // padding: '16px',
            //   aspectRatio: "240% / 320%", // Set desired aspect ratio
          }}
        />
      </Box>
    </Root>
  );
};

export default DonutChart;
